<template>
  <div class="mnp-in-summary">
    <div class="summary-head-box">
    <slot name="txtBefore"></slot>
    <slot name="txtBeforeData"></slot>
    <b-row class="providerKey">
      <b-col md="" sm="" class="label">
        <slot name="lblProviderKey">Name des Anbieters:</slot>
      </b-col>
      <b-col md="" sm="" class="value">
        {{selectedKeys.providerKey}}
      </b-col>
    </b-row>
    <b-row class="portationMsisdn">
      <b-col md="" sm="" class="label">
        <slot name="lblPortationMsisdn">Zu portierende Rufnummer:</slot>
      </b-col>
      <b-col md="" sm="" class="value">
        {{portationMsisdn}}
      </b-col>
    </b-row>
    <b-row class="fullName">
      <b-col md="" sm="" class="label">
        <slot name="lblFullName">Name im alten Vertrag:</slot>
      </b-col>
      <b-col md="" sm="" class="value">
        {{salutation(person.gender)}} {{person.firstName}} {{person.lastName}}
      </b-col>
    </b-row>
    <b-row class="birthDate">
      <b-col md="" sm="" class="label">
        <slot name="lblBirthDate">Geburtstag im alten Vertrag:</slot>
      </b-col>
      <b-col md="" sm="" class="value">
        {{person.birthDate}}
      </b-col>
    </b-row>
    <slot name="txtAfterData"></slot>
    <div class="payment-information">
      <slot name="txtBeforePaymentInformation"></slot>
      <ChangePaymentViewWrapper :show-stepper="false">
        <template v-for="slot in possibleChildSlotsFor('ViewWrapper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ChangePaymentViewWrapper>
      <slot name="txtAfterPaymentInformation"></slot>
    </div>
    <slot name="txtAfter"></slot>
  </div>
  </div>

</template>

<script>
import ChangePaymentViewWrapper from '@/components/process/generic/Payment/ChangePayment/ViewWrapper.vue'
import { mapGetters } from 'vuex'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'mnpInSummary'

export default {
  name: 'MnpInSummary',
  props: {},
  components: {
    ChangePaymentViewWrapper
  },
  computed: {
    isNoPayment () {
      return this.paymentInformation.paymentType === null
    },
    isCreditCard () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'creditCard'
      }
      return false
    },
    isBankAccount () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'bankAccount'
      }
      return false
    },
    ...mapGetters('mnpIn', [
      'person', 'selectedKeys', 'portationMsisdn'
    ])
  },
  methods: {
    salutation (gender) {
      switch (gender) {
        case 'MALE': return 'Herr'
        case 'FEMALE': return 'Frau'
      }
    },
    back () {
      this.goToStep(this.previousStep)
    }
  },
  mixins: [
    slotProxy()
  ],
  apollo: {
    paymentInformation: function () {
      return wrapQuery(
        gql`query changePayment {
          paymentInformation {
            paymentType {
            ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
           }
          }
        }`, this, 'paymentInformation'
      )
    }
  }
}
</script>
